import client from './client';
import type { HealthNodeDetail, HealthOverview, MaintenanceState } from '../types';

export const getHealthOverview = () => client.get<HealthOverview>('/api/health/overview');
export const getNodeHealth = (id: number) => client.get<HealthNodeDetail>(`/api/health/nodes/${id}`);

export const getMaintenance = () => client.get<MaintenanceState>('/api/maintenance');
export const closeMaintenance = () => client.post<MaintenanceState>('/api/maintenance/close');
export const openMaintenance = (hours: number) => client.post<MaintenanceState>('/api/maintenance/open', { hours });
export const clearMaintenanceOverride = () => client.delete<MaintenanceState>('/api/maintenance/override');
